/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Show_Next_EventInputs */

const en_player_show_next_event = /** @type {(inputs: Player_Show_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show next event`)
};

const fr_player_show_next_event = /** @type {(inputs: Player_Show_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher l'evenement suivant`)
};

const de_player_show_next_event = /** @type {(inputs: Player_Show_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächstes Ereignis anzeigen`)
};

const it_player_show_next_event = /** @type {(inputs: Player_Show_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra il prossimo evento`)
};

const ru_player_show_next_event = /** @type {(inputs: Player_Show_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать следующее событие`)
};

const es_player_show_next_event = /** @type {(inputs: Player_Show_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar próximo evento`)
};

const zh_cn2_player_show_next_event = /** @type {(inputs: Player_Show_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示下一个活动`)
};

const ja_player_show_next_event = /** @type {(inputs: Player_Show_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベントを表示`)
};

const hi_player_show_next_event = /** @type {(inputs: Player_Show_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला कार्यक्रम दिखाएँ`)
};

const pt_pt2_player_show_next_event = /** @type {(inputs: Player_Show_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar o próximo evento`)
};

/**
* | output |
* | --- |
* | "Show next event" |
*
* @param {Player_Show_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_show_next_event = /** @type {((inputs?: Player_Show_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Show_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_show_next_event(inputs)
	if (locale === "de") return de_player_show_next_event(inputs)
	if (locale === "it") return it_player_show_next_event(inputs)
	if (locale === "ru") return ru_player_show_next_event(inputs)
	if (locale === "es") return es_player_show_next_event(inputs)
	if (locale === "zh-CN") return zh_cn2_player_show_next_event(inputs)
	if (locale === "ja") return ja_player_show_next_event(inputs)
	if (locale === "hi") return hi_player_show_next_event(inputs)
	if (locale === "pt-PT") return pt_pt2_player_show_next_event(inputs)
	return en_player_show_next_event(inputs)
});